import { Popup } from '../../../ui/popup/popup';
import React from 'react';
import { rootActions, useAppDispatch, useAppSelector } from '../data/store';
import { getCompareBundlesUrl } from '../../compare-bundles/domain/compare-bundles-provider';
import { CompareTypeEnum } from './compare-type-enum';
import { getCompareServersUrl } from '../../compare-servers/domain/compare-servers-provider';

const ComparePopup = () => {
    const dispatch = useAppDispatch();
    const compareType = useAppSelector(store => store.compareType);

    const close = () => {
        dispatch(
            rootActions.main({
                isComparePopupVisible: false,
            })
        );
    };

    const performRedirect = () => {
        window.location.href = compareType === CompareTypeEnum.Bundles ? getCompareBundlesUrl() : getCompareServersUrl();
    };

    return (
        <Popup width="290px" height="200px" close={ close }>
            <div className="flex flex-col justify-center items-center w-full h-full text-center">
                { compareType === CompareTypeEnum.Bundles && <p className="mb-4">You may compare up to 4 bundles at a time.</p> }
                { compareType === CompareTypeEnum.SoundGridServers && <p className="mb-4">You may compare up to 4 servers at a time.</p> }
                <button type="button" className="w-btn" onClick={ performRedirect }>
                    Compare Now
                </button>
            </div>
        </Popup>
    )
};

export default ComparePopup;